/**
 * Configuration service for fetching runtime configuration from the server
 */

// Default configuration in case the server is not available
const DEFAULT_CONFIG = {
  API_URL: process.env.NODE_ENV === 'development' ? '' : 'http://localhost:5001',
};

/**
 * Fetch the runtime configuration from the server
 * @returns {Promise<Object>} - Runtime configuration
 */
export const fetchConfig = async () => {
  try {
    console.log('Fetching fresh configuration from server (no cache)');

    // Derive the API URL from the browser's current origin — the SPA and API
    // are always served from the same Express server, so window.location.origin
    // is always correct regardless of which domain is used to access the portal.
    const apiUrl = process.env.NODE_ENV === 'development'
      ? ''
      : (window.location.origin.includes('localhost')
          ? 'http://localhost:5001'
          : window.location.origin);

    const config = { API_URL: apiUrl };
    console.log('Resolved configuration from origin:', config);
    return config;
  } catch (error) {
    console.error('Error fetching configuration:', error);
    return DEFAULT_CONFIG;
  }
};

/**
 * Get the API URL from the configuration
 * @returns {Promise<string>} - API URL
 */
export const getApiUrl = async () => {
  const config = await fetchConfig();
  return config.API_URL || DEFAULT_CONFIG.API_URL;
};

/**
 * Initialize the configuration
 * This should be called as early as possible in the application lifecycle
 */
export const initConfig = async () => {
  try {
    const config = await fetchConfig();
    console.log('Initialized configuration:', config);
    
    // Make the configuration available globally
    window.RUNTIME_CONFIG = config;
    
    return config;
  } catch (error) {
    console.error('Error initializing configuration:', error);
    
    // Make the default configuration available globally
    window.RUNTIME_CONFIG = DEFAULT_CONFIG;
    
    return DEFAULT_CONFIG;
  }
};
